<template>
  <div class="dashboard">
    <!-- <v-layout row justify-center class="mt-2">
      <h1 class="subheading grey--text">Dashboard</h1>
    </v-layout> -->
    <v-container class="my-5">
      <!-- <v-layout row class="mb-3">
        <v-btn depressed small color="grey lighten-5" @click="sortBy('title')">
          <v-icon left small>folder_open</v-icon>
          <span class="caption text-lowercase">by project name</span>
        </v-btn>
        <v-btn depressed light small color="grey lighten-5" @click="sortBy('person')">
          <v-icon left small>person</v-icon>
          <span class="caption text-lowercase">by person</span>
        </v-btn>
      </v-layout> -->

      <!-- <v-card flat v-for="project in projects" :key="project.title">
        <v-layout row :class="`pa-3 project ${project.status}`">
          <v-flex xs12 md6>
            <div class="caption grey--text">Project Title</div>
            <div>{{project.title}}</div>
          </v-flex>
          <v-flex xs6 sm4 md2>
            <div class="caption grey--text">Person</div>
            <div>{{project.person}}</div>
          </v-flex>
          <v-flex xs6 sm4 md2>
            <div class="caption grey--text">Due by</div>
            <div>{{project.due}}</div>
          </v-flex>
          <v-flex xs2 sm4 md2>
            <div class="text-center">
              <v-chip small :class="`${project.status} white--text caption my-3`">{{project.status}}</v-chip>
            </div>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
      </v-card> -->
      <Ftickets />
    </v-container>
  </div>
</template>

<script>
// import {db} from '@/fb'
import Ftickets from '@/components/api/Ftickets'

export default {
  name: 'dashboard',
  components:{Ftickets},
  data(){
    return {
      // projects: []
    }
  },
  // methods:{
  //   sortBy(prop){
  //     this.projects.sort((a,b)=> a[prop] < b[prop] ? -1:1)
  //   }
  // },
  // created(){
  //   db.collection('projects').onSnapshot(res => {
  //     const changes = res.docChanges();
  //     changes.forEach(change =>{
  //       if(change.type==='added'){
  //         this.projects.push({
  //           ...change.doc.data(),
  //           id: change.doc.id
  //         })
  //       }
  //     })
  //   })
  // },
  // mounted(){
  //   /* eslint-disable no-console */
  //   console.log(auth.currentUser)
  //   /* eslint-enable no-console */
  // },
}
</script>

<style>
/* .project.complete {
  border-left: 4px solid #3cd1c2
}

.project.ongoing {
  border-left: 4px solid orange
}

.project.overdue {
  border-left: 4px solid rgb(10, 2, 0)
}
.v-chip.complete{
  background-color: #3cd1c2 !important;
}
.v-chip.overdue{
  background-color: tomato !important;
}
.v-chip.ongoing{
  background-color: orange !important;
} */
</style>